module.exports = __webpack_public_path__ + "static/media/ticket.6e11521d.svg";